import { useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { stringToTag } from "@opendash/ui";
import { Button, Card, Flex, Form } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { MaterialInput } from "../../items/components/MaterialInput";

type Props = {
  source: Source;
};

type ValueType = {
  [key: string]: {
    selected: string;
    count: number;
  };
};

export type ItemSelectionList_FormValues = {
  items: ValueType[];
};

export default observer((props: Props) => {
  const t = useTranslation();
  const sourceArray = useMemo(() => [props.source], [props.source]);

  return (
    <Form.List name={["items", props.source.id]}>
      {(fields, operation, meta) => {
        return (
          <Card
            title={stringToTag(
              t(
                "maintenance:schedules.multi-source-schedule-modal.items.label",
                { source: props.source.get("name") }
              ),
              "'"
            )}
          >
            {fields.map((field) => {
              return (
                <Flex
                  key={props.source.id + field.name + ".header"}
                  gap="8px"
                  justify="space-between"
                  align="flex-end"
                >
                  <Form.Item
                    key={props.source.id + field.name + ".selected"}
                    name={[field.name, "selected"]}
                    label={stringToTag(
                      t(
                        "maintenance:schedules.multi-source-schedule-modal.items.selected",
                        { source: props.source.get("name") }
                      ),
                      "'"
                    )}
                    style={{ flex: 1 }}
                  >
                    <MaterialInput sources={sourceArray} />
                  </Form.Item>
                  <Button
                    onClick={() => operation.remove(field.name)}
                    style={{ marginBottom: "24px" }}
                    type="text"
                    shape="circle"
                    danger
                  >
                    <Icon icon="fa:trash" />
                  </Button>
                </Flex>
              );
            })}
            <Button
              onClick={() => operation.add()}
              type="dashed"
              style={{ width: "100%" }}
            >
              {t("maintenance:schedules.multi-source-schedule-modal.items.add")}
            </Button>
          </Card>
        );
      }}
    </Form.List>
  );
});
